module.exports = __webpack_public_path__ + "img/7-muistolle.6563555d.jpg";